import React, { Fragment } from 'react';
import { getKeyValue, getListValue, t } from 'Src/i18n';
import { Card } from 'Components/frameworks/card/Card';
import { INLINE_2 } from 'Components/frameworks/card/Card.constants';
import { Title } from 'Components/frameworks/title/Title';
export const GreatMembersExclusivity = () => {
  const steps = getListValue('customerAccount.greatMember.stepsSection.steps');
  const stepsEnabled = getKeyValue('customerAccount.greatMember.stepsSection.stepsEnabled');
  const articleEnabled = getKeyValue('customerAccount.greatMember.stepsSection.article.enabled');
  return (
    <Fragment>
      {articleEnabled && stepsEnabled && (
        <Title className="mb-40" hLevel={2} theme="title-brand-n0">
          {t('customerAccount.greatMember.stepsSection.title')}
        </Title>
      )}
      {stepsEnabled && (
        <ul className="mb-80 grid grid-cols-2 sm:mb-120 sm:grid-cols-3 sm:divide-x">
          {(steps || []).map((item, i) => (
            <li
              className="flex flex-col items-center gap-20 p-20 text-center text-16 font-semibold text-black"
              key={item}
            >
              <span className="flex aspect-square size-48 items-center justify-center rounded-full bg-black font-bold leading-1 text-white">
                {i + 1}
              </span>
              {item}
            </li>
          ))}
        </ul>
      )}
      {articleEnabled && (
        <Card
          heading={{
            hLevel: 3,
            title: t('customerAccount.greatMember.stepsSection.article.title'),
          }}
          layout={INLINE_2}
          media={{
            url: t('customerAccount.greatMember.stepsSection.article.imageUrl'),
          }}
          text={{
            text: t('customerAccount.greatMember.stepsSection.article.text'),
          }}
        />
      )}
    </Fragment>
  );
};
